/* unplugin-vue-components disabled */import { render } from "./BannerSettingView.vue?vue&type=template&id=d307ac66&scoped=true"
import script from "./BannerSettingView.vue?vue&type=script&lang=js"
export * from "./BannerSettingView.vue?vue&type=script&lang=js"

import "./BannerSettingView.vue?vue&type=style&index=0&id=d307ac66&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d307ac66"]])

export default __exports__